import { Ticker } from '@cian/adfox-templates';

import * as React from 'react';

import { SectionBlock } from '../SectionBlock';

import * as styles from './VideoFromDeveloperBlock.css';

type VideoFromDeveloperBlockProps = {
  src: string;
  poster: string | undefined;
  disclaimer: string | undefined | null;
};

export const VideoFromDeveloperBlock: React.FC<VideoFromDeveloperBlockProps> = ({ src, poster, disclaimer }) => {
  return (
    <SectionBlock title="Видео от застройщика" sectionTabTitle="Видео" id="video-from-developer">
      <div className={styles['container']}>
        <video data-testid="video" className={styles['video']} src={src} controls poster={poster} />
        {disclaimer && (
          <div data-testid="video-disclaimer" className={styles['disclaimer']}>
            <Ticker withBackground text={disclaimer} />
          </div>
        )}
      </div>
    </SectionBlock>
  );
};
